// extracted by mini-css-extract-plugin
export default {"licenseKey":"LicenseKeyPillbox_licenseKey__TDjgf"};